export const HOUSEHOLD_CODE_CHARACTER_COUNT = 7;

const POSITIONAL_HOUSEHOLD_CODE_PATTERN = /^[A-Z0-9_]{4}-[A-Z0-9_]{3}$/i;

export function getHouseholdCodeCharacters(value: string): string[] {
  const rawValue = String(value ?? "").trim().toUpperCase();

  if (POSITIONAL_HOUSEHOLD_CODE_PATTERN.test(rawValue)) {
    return rawValue
      .replace("-", "")
      .split("")
      .map((character) => (character === "_" ? "" : character));
  }

  const characters = rawValue
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, HOUSEHOLD_CODE_CHARACTER_COUNT)
    .split("");

  return Array.from(
    { length: HOUSEHOLD_CODE_CHARACTER_COUNT },
    (_, index) => characters[index] ?? "",
  );
}

export function formatHouseholdCodeCharacters(
  characters: readonly string[],
): string {
  const normalized = Array.from(
    { length: HOUSEHOLD_CODE_CHARACTER_COUNT },
    (_, index) => normalizeHouseholdCodeCharacter(characters[index] ?? ""),
  );

  if (normalized.every((character) => !character)) {
    return "";
  }

  const positional = normalized.map((character) => character || "_");

  return `${positional.slice(0, 4).join("")}-${positional.slice(4).join("")}`;
}

export function normalizeHouseholdCode(value: string): string {
  return formatHouseholdCodeCharacters(
    getHouseholdCodeCharacters(value),
  );
}

export function isCompleteHouseholdCode(value: string): boolean {
  return /^[A-Z0-9]{4}-?[A-Z0-9]{3}$/i.test(value.trim());
}

export function normalizeHouseholdCodeCharacter(value: string): string {
  return value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(-1);
}